import * as React from 'react';
import TimeInterval from './TimeInteval';

interface HeadwayPopupInfo {
    vehicleId: string;
    secondsReal: number;
}

interface LiveMapVehiclePopupContentProps {
    routeName: string;
    headsign: string;
    lastStopName: string;
    scheduled: boolean;
    delaySeconds: number;
    ahead?: HeadwayPopupInfo;
    behind?: HeadwayPopupInfo;
}

const rowStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 12,
};

const labelStyle: React.CSSProperties = {
    fontWeight: 600,
    color: '#4b5563',
};

const LiveMapVehiclePopupContent: React.FC<LiveMapVehiclePopupContentProps> = ({
    routeName,
    headsign,
    lastStopName,
    scheduled,
    delaySeconds,
    ahead,
    behind,
}) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4, minWidth: 220 }}>
        <div style={rowStyle}>
            <span style={labelStyle}>Route</span>
            <span>{routeName}</span>
        </div>
        <div style={rowStyle}>
            <span style={labelStyle}>Headsign</span>
            <span>{headsign}</span>
        </div>
        <div style={rowStyle}>
            <span style={labelStyle}>Last Stop</span>
            <span>{lastStopName}</span>
        </div>
        <div style={rowStyle}>
            <span style={labelStyle}>Status</span>
            <span>
                {scheduled
                    ? 'Scheduled'
                    : (
                        <TimeInterval seconds={delaySeconds} mark={true} />
                    )}
            </span>
        </div>
        {!ahead
            ? null
            : (
                <div style={rowStyle}>
                    <span style={labelStyle}>Ahead</span>
                    <span>
                        {ahead.vehicleId}
                        {' • '}
                        <TimeInterval seconds={ahead.secondsReal} />
                    </span>
                </div>
            )}
        {!behind
            ? null
            : (
                <div style={rowStyle}>
                    <span style={labelStyle}>Behind</span>
                    <span>
                        {behind.vehicleId}
                        {' • '}
                        <TimeInterval seconds={behind.secondsReal} />
                    </span>
                </div>
            )}
    </div>
);

export default LiveMapVehiclePopupContent;
